// Form errors are marked with [data-form-error-marker] on both stacks: server-rendered ones by
// UiFormBuilder / Ui::Form::Group, Inertia ones by the FieldError component in ~/common/form.
export function scrollToFirstFormError(root: Element): void {
  root
    .querySelector("[data-form-error-marker]")
    ?.scrollIntoView({ block: "center", behavior: "smooth" });
}
